/** Fired from `index.js` during “Loading application…” when the link looks slow (3G-class; includes DevTools-throttled profiles). */
export const BOOT_APP_3G_SLOW_EVENT = 'sparkle:boot-app-3g-slow'

/** `navigator.connection` (or vendor-prefixed) when available. */
export function getNavigatorConnection() {
  if (typeof navigator === 'undefined') return null
  return navigator.connection || navigator.mozConnection || navigator.webkitConnection || null
}

/**
 * True when Network Information suggests a 3G-class link for boot UX.
 * DevTools “Slow 3G” / throttling often keeps `effectiveType` as `4g` but raises `rtt` and lowers `downlink`.
 */
export function isSlowBootConnectionHint(connection) {
  if (!connection || typeof connection !== 'object') return false
  const et = connection.effectiveType
  if (et === '3g' || et === '2g' || et === 'slow-2g') return true

  const rtt = typeof connection.rtt === 'number' && !Number.isNaN(connection.rtt) ? connection.rtt : null
  if (rtt != null && rtt >= 300) return true

  const downlink = typeof connection.downlink === 'number' && !Number.isNaN(connection.downlink) ? connection.downlink : null
  if (downlink != null && downlink > 0 && downlink <= 2.5) return true

  return false
}
